// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getHeader, getPageStateByType } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { LinkModel, MappedLink } from "@steiner/Overrides/Widgets/Header/MainNavigation";

export const getMainNavigationWidgetFields = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find(widget => {
        return widget.type === "Header/MainNavigation";
    })?.fields;
};

export const getMiniSignInWidgetFields = (state: ApplicationState) => {
    const page = getPageStateByType(state, "Header").value || nullPage;
    return getWidgetsByPageId(state, page.id).find(widget => {
        return widget.type === "Common/HeaderSignIn";
    })?.fields;
};

export const getMiniCartWidgetFields = (state: ApplicationState) => {
    const page = getPageStateByType(state, "Header").value || nullPage;
    return getWidgetsByPageId(state, page.id).find(widget => {
        return widget.type === "Common/CartLink";
    })?.fields;
};

export const getLogoImageWidgetFields = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Basic/Logo";
    })?.fields;
};

export const getHeaderSearchInputWidgetFields = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Header/HeaderSearchInput";
    })?.fields;
};

export const getSecondaryWidgetFields = (state: ApplicationState) => {
    const page = getPageStateByType(state, "Header").value || nullPage;
    return getWidgetsByPageId(state, page.id).find(widget => {
        return widget.type === "Header/HeaderLinkList";
    })?.fields;
};
